import Material from '@components/common/faq-material'
import { useState } from 'react'
import { FastlyImage } from '@components/common/image'

const IMAGE_PATH = '/images/home/'
type Props = {
  earnings: string
}
const Faq = ({ earnings }: Props) => {
  const [activeAccordion, setActiveAccordion] = useState('')
  return (
    <div className="flex flex-wrap justify-center pb-10">
      <div className="mt-5 md:mt-20">
        <FastlyImage
          src={`${IMAGE_PATH}faq.png`}
          height={130}
          width={130}
          alt="kids cheering"
        />
      </div>
      <div className="flex flex-col w-full px-10 md:mt-16 md:w-1/2">
        <h2 className="text-3xl text-center font-600 text-grey-900 md:text-left">
          All your questions answered
        </h2>
        <div className="flex flex-col justify-around mt-4">
          <Material
            title="What is the application process to become a teacher?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
          >
            <p className="pb-4 text-base text-grey">
              Our application process have five simple steps: Submit your
              application, share a demo video, take a technical assessment, do
              an interview, and sign the contract. For more information on
              application process,{' '}
              <a
                href="#becoming-a-teacher"
                className="cursor-pointer text-orange hover:underline"
              >
                click here.
              </a>
            </p>
          </Material>
          <Material
            title="How much will I earn as a teacher?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
          >
            <p className="pb-4 text-base text-grey">
              Our teachers make around {earnings} a month on average. For more
              information on teacher earnings and incentives,{' '}
              <a
                href="#unmatched-earning"
                className="cursor-pointer text-orange hover:underline"
              >
                click here.
              </a>
            </p>
          </Material>
          <Material
            title="Is there a maximum number of classes I can teach?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
          >
            <p className="pb-4 text-base text-grey">
              We set no limit on how many classes a teacher can teach. You can
              teach as many class as you like.
            </p>
          </Material>
          <Material
            title="How are teacher earnings calculated?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
          >
            <p className="pb-4 text-base text-grey">
              Your earnings will be calculated based on the number of classes
              you teach. The more classes you teach the more you earn.
            </p>
          </Material>
          <Material
            title="Can I apply if I don't have a bachelor's degree?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
          >
            <p className="pb-4 text-base text-grey">
              Unfortunately, we only accept teachers with a bachelor&apos;s
              degree. For more information on our teacher eligibility
              requirements,{' '}
              <a
                href="#eligibility-criteria"
                className="cursor-pointer text-orange hover:underline"
              >
                click here.
              </a>
            </p>
          </Material>
          <Material
            title="What kind of training do I get as a teacher?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
          >
            <p className="pb-4 text-base text-grey">
              We offer extensive training to our teachers to develop their
              teaching and communication skills. Our teachers are trained
              extensively on standard operating procedures, curriculum,
              communication and more. We also have an LMS that allows you to
              learn asynchronously. For more information on teacher training,{' '}
              <a
                href="#all-support-you-need"
                className="cursor-pointer text-orange hover:underline"
              >
                click here.
              </a>
            </p>
          </Material>
          <Material
            title="What resources does Codingal provide to its teachers?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
          >
            <p className="pb-4 text-base text-grey">
              Our teachers get exclusive access to our in-depth coding
              curriculum, detailed lesson plans, tutorials, class activities,
              standard operating procedures (SOP), and much more. For more
              information on our resources,{' '}
              <a
                href="#all-support-you-need"
                className="cursor-pointer text-orange hover:underline"
              >
                click here.
              </a>
            </p>
          </Material>
        </div>
      </div>
    </div>
  )
}

export default Faq
